import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styled from 'styled-components';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds";
import { rootStyle } from "../../styles";
var ListItemElement = styled.li.withConfig({
  displayName: "ListItem__ListItemElement",
  componentId: "sc-14osqn3-0"
})(["", ";list-style-type:none;"], rootStyle());

/**
* **ListItem** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ListItem) 
*
* null
*
* 
*
* @example
* () => <ListItem>List Item</ListItem>;
*
*/
export var ListItem = /*#__PURE__*/React.forwardRef(function ListItem(_ref, ref) {
  var props = _extends({}, _ref);
  return /*#__PURE__*/React.createElement(ListItemElement, Object.assign({}, props, {
    ref: ref,
    "data-encore-id": ENCORE_DATA_IDS.ListItem
  }));
});